import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkLayoutSpaces, UitkLayoutSizes, UitkLayout } from 'uitk-react-layout';
import styles from './uitk-layout-columns.css';
import { UitkLayoutColumnCounts } from './types.esm.js';
var getClassNameList = classNames.bind(styles);
var UitkLayoutColumns = function (props) {
  var children = props.children,
    className = props.className,
    space = props.space,
    tag = props.tag,
    columns = props.columns,
    minWidth = props.minWidth,
    attributes = __rest(props, ["children", "className", "space", "tag", "columns", "minWidth"]);
  var baseClass = 'uitk-layout-columns';
  var wrapperClassNames = getClassNameList(baseClass, columns && "".concat(baseClass, "-").concat(UitkLayoutColumnCounts.get(columns)), space && "".concat(baseClass, "-").concat(UitkLayoutSpaces.get(space)), minWidth && "".concat(baseClass, "-minwidth-").concat(UitkLayoutSizes.get(minWidth)), className);
  return React.createElement(UitkLayout, __assign({
    className: wrapperClassNames,
    tag: tag
  }, attributes), children || null);
};
export { UitkLayoutColumns };